










// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator';
import { getDefaultAloPersonne, AloPersonne } from '@/models/alo/AloPersonne';
import * as rules from '@/utils/validationRules'
import EditBasePersonne from '@/components/personne/edit/EditBasePersonne.vue';

@Component({
  name: 'EditConfig',    
  components:{EditBasePersonne},  
  props: {   
    priorityEditable:{
      type:Boolean,
      default:true      
    },
    enableEditable:{
      type:Boolean,
      default:true      
    },  
  }
})
export default class EditConfig extends Vue {
  
  private personne = getDefaultAloPersonne()
  private priorityEditable!:boolean
  private enableEditable!:boolean
 
  ruleRequired(v:string) {
    return rules.ruleRequired(v)
  }

  edit(item:AloPersonne) {    
    this.personne = (this.$refs.baseEdit as EditBasePersonne).edit(item)
  }   
}
